import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ReactNativeAappIcon,
  ReactNativeMigIcon,
  ReactNativeMain1Icon,
  ReactNativeAPIIcon,
  ReactNativeConIcon,
  ReactNativeMain2Icon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: ReactNativeAappIcon,
    title: "React Native App Development",
    description:
      "Our expert React app developers craft bespoke React Native applications from scratch by using the latest frameworks and tools that deliver impeccable user experience. We use the flexibility of React Native CLI or Expo for efficient development and project management. Taking into account all your business requirements, our team ensures a custom-made approach to React Native hybrid development, creating solutions that smoothly combine efficiency and cost-effectiveness. We bring your custom React Native application vision to life with the utmost technological excellence.",
  },
  {
    icon: ReactNativeMigIcon,
    title: "React Native Mobile App Migration",
    description:
      "Whether you're looking to re-engineer your existing mobile and web applications or transitioning from another platform to React Native for an improved user experience. Our team of React app developers possesses the necessary capabilities, skills, and expertise in React Native app development. We optimize codebases for competence, modernize UI/UX, and guarantee cross-platform compatibility, saving time and costs.",
  },
  {
    icon: ReactNativeMain1Icon,
    title: "React Native App Design",
    description:
      "Our skilled UX strategists collaborate with visual designers to create personalized design experiences. From wireframes and prototyping to UI design, our mission is to deliver engaging, human-centered app experiences that impress clients. We ensure your React Native app stands out with engaging and visually stunning design elements.",
  },
  {
    icon: ReactNativeAPIIcon,
    title: "API & Component Mobile App Development",
    description:
      "Our skilled React Native developers specialize in API & Component Mobile App Development to lift the functionality of iOS and Android platforms. Crafting a dedicated server for your React Native app and implementing a robust API, we ensure smooth communication between the mobile interface, the server, and practical components. With a precise integration of APIs and strategically designed components, our React app developers improve overall performance of your app but also pave the way for a responsive user experience.",
  },
  {
    icon: ReactNativeConIcon,
    title: "React Native App Consulting Services",
    description:
      "While React Native app development offers numerous advantages for businesses, but sometimes the framework may not be the ideal fit for every app development scenario. Therefore, our team of React Native app developers engages in in-depth discussions with each client to know their product vision. As a trusted React Native app development company, we understand the diverse business needs and provide custom solutions to fulfill their unique business requirements.",
  },
  {
    icon: ReactNativeMain2Icon,
    title: "React Native Support & Maintenance",
    description:
      "We understand that the journey after the deployment is far more critical, so TekRevol provides continual support and maintenance to its clients. We can assist you with maintaining and expanding the functionality of any React Native apps you currently have. You can be confident that your project will be in good hands because our React Native development team has years of experience. Our React Native developers ensure that your app remains updated, error-free, and constantly meets user needs.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Drive Your Business Forward with TekRevol’s React Native Developer
              Services
            </h2>
            <p className="impro_para">
              As a globally recognized React Native app development company, we
              offer a comprehensive range of services to build cutting-edge
              high-performing apps for multiple platforms. Our React app
              developers utilize the latest tech stack to develop digital
              solutions that redefine user experiences and drive business
              growth. Here are our React Native app development services in UK:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
